import { render } from "./SliderOnMainComponent.vue?vue&type=template&id=7c2f9f9e"
import script from "./SliderOnMainComponent.vue?vue&type=script&lang=js"
export * from "./SliderOnMainComponent.vue?vue&type=script&lang=js"

import "./SliderOnMainComponent.vue?vue&type=style&index=0&id=7c2f9f9e&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__